import React from 'react'

import { Card, Container, Grid, Header, Image, Loader } from 'semantic-ui-react'

import NumberCard from './../../../drive/NumberCard'
import shieldIcon from './../../../../images/grafix-icon/icon-shield-user.svg'
import EllipsisTooltip from '../../../common/EllipsisTooltip';

import PlatformAccountsList from '../Drive/Table/PlatformAccountsList'
import numberFormatter from '../../../../helpers/numberFormatter';
import CountLabel from '../../../common/CountLabel';

export default class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        const { loadingAccountsData } = this.props

        return (
            <Container fluid >
                <Grid >
                    <Grid.Row>
                        <Grid.Column width={5}>
                            <div className="welcomeCard">
                                <Image src={shieldIcon} />
                                <div className="cardName">
                                    <label>  <EllipsisTooltip name={`Welcome ${this.props.user.firstName} ${this.props.user.lastName}`} />  </label>
                                    <span> You are a platform administrator  </span>
                                </div>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={11}>

                            <Card.Group itemsPerRow={6}>

                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.activeSessions) : <Loader active inline size="tiny" />}
                                        text="Active Session" />
                                </Card>
                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.accounts.length - 1) : <Loader active inline size="tiny" />}
                                        text="Accounts" />
                                </Card>
                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.orgCount) : <Loader active inline size="tiny" />}
                                        text="Workspaces" />
                                </Card>
                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.userCount) : <Loader active inline size="tiny" />}
                                        text="Users" />
                                </Card>
                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.playbookCount) : <Loader active inline size="tiny" />}
                                        text="Playbook" />
                                </Card>
                                <Card  >
                                    <NumberCard
                                        name={!loadingAccountsData ? numberFormatter(this.props.contentCount) : <Loader active inline size="tiny" />}
                                        text="Content" />
                                </Card>
                            </Card.Group>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <Container fluid className="listingUsers ">
                                <div className="listHeader">
                                    <Header as='h4' floated='left'>
                                        Subscriptions
                                        <CountLabel
                                            count={this.props.accounts && this.props.accounts.length ? this.props.accounts.length - 1 : null}
                                        />
                                    </Header>

                                </div>
                                <div className="listTab">
                                    <PlatformAccountsList
                                        {...this.props} />
                                </div>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        )
    }
}

